/* eslint-disable */
export default {
    state: {
        post: {
            searchingCount: false,
            searchCount: 0,
            loadingPosts: false,
            statusOk: false,
            errMessage: "",
            okMessage: "",
            total: 100,
            itemsPerPage: 10,
            page: 0,
            items: []
        },
        imageUploading: false,
        imageDeleting: false,
        imageResponseStatusOk: true,
        imageResponseMessage: ""
    },
    mutations: {
        'ACCOUNT_LOADING_POSTS' (state, val) {
            state.post.loadingPosts = val;
        },
        'ACCOUNT_LOADING_POSTS_SUCCESS' (state, val) {
            state.post.statusOk = true;
            state.post.total = val.total;
            state.post.itemsPerPage = val.itemsPerPage;
            state.post.page = val.page;
            state.post.items = val.items;
            state.post.errMessage = "";
        },
        'ACCOUNT_LOADING_POSTS_ERROR' (state, val) {
            state.post.statusOk = false;
            state.post.errMessage = val;
            state.post.okMessage = "";
        },
        'ACCOUNT_SEARCHING_COUNT' (state, val) {
            state.post.searchingCount = val;
        },
        'ACCOUNT_SEARCH_COUNT' (state, val) {
            state.post.searchCount = val.total;
        },
        'ACCOUNT_IMAGE_DELETING' (state, val) {
            state.imageDeleting = val;
        },
        'ACCOUNT_IMAGE_UPLOADING' (state, val) {
            state.imageUploading = val;
        },
        'ACCOUNT_IMAGE_SUCCESS' (state, val) {
            state.imageResponseStatusOk = true;
            state.imageResponseMessage = val;
        },
        'ACCOUNT_IMAGE_ERROR' (state, val) {
            state.imageResponseStatusOk = false;
            state.imageResponseMessage = val;
        }
    },
    actions: {
        'ACCOUNT_FETCH_POSTS' ({commit, rootState}, query) {    
            console.log("query", query);
            query.sort = "-_id";
            query.user = rootState.authenticatedUserID;
            commit('ACCOUNT_LOADING_POSTS', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('ACCOUNT_LOADING_POSTS', false);
                commit('ACCOUNT_LOADING_POSTS_SUCCESS', resp.data.response);
                console.log("all posts", resp);
            })
            .catch(err => {
                commit('ACCOUNT_LOADING_POSTS', false);
                commit('ACCOUNT_LOADING_POSTS_ERROR', 'Error. Server error');
                console.log("all posts err", err);
            });
        },
        'ACCOUNT_FETCH_COUNT' ({commit, rootState}, query) {
            console.log("query", query);
            query.user = rootState.authenticatedUserID;
            commit('ACCOUNT_SEARCHING_COUNT', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('ACCOUNT_SEARCHING_COUNT', false);
                commit('ACCOUNT_SEARCH_COUNT', resp.data.response);
                console.log("resp", resp);
            })
            .catch(err => {
                commit('ACCOUNT_SEARCHING_COUNT', false);
                commit('ACCOUNT_SEARCH_COUNT', {total: 0});
                console.log("resp err", err);
            });
        },
        'ACCOUNT_DELETE_IMAGE' ({commit, rootState}) {
            commit('ACCOUNT_IMAGE_DELETING', true);
            axios.delete(`/user/${rootState.authenticatedUserID}/image`)
            .then(resp => {
                commit('ACCOUNT_IMAGE_DELETING', false);
                commit('ACCOUNT_IMAGE_SUCCESS', rootState.locale === "en" ? 'Image successfully deleted':'Kuva onnistuneesti poistettu');
                commit('AUTH_USER', resp.data.response);
                console.log("resp", resp);
            })
            .catch(err => {
                commit('ACCOUNT_IMAGE_DELETING', false);
                commit('ACCOUNT_IMAGE_ERROR', rootState.locale === "en" ? 'Error. Image failed to delete':'Error. Kuvaa ei voitu poistaa');
                console.log("resp err", err);
            });
        },
        'ACCOUNT_UPLOAD_IMAGE' ({commit, rootState}, payload) {
            axios.put(`/user/${rootState.authenticatedUserID}/image`, payload)
            .then(resp => {
                commit('ACCOUNT_IMAGE_UPLOADING', false);
                commit('ACCOUNT_IMAGE_SUCCESS', rootState.locale === "en" ? 'Image successfully uploaded':'Kuva onnistuneesti ladattu');
                commit('AUTH_USER', resp.data.response);
                console.log("resp", resp);
            })
            .catch(err => {
                commit('ACCOUNT_IMAGE_UPLOADING', false);
                commit('ACCOUNT_IMAGE_ERROR', rootState.locale === "en" ? 'Error. Image failed to upload.':'Error. Kuvaa ei voitu ladata.');
                console.log("resp err", err);
            });
        }
    }
};